module.exports = __webpack_public_path__ + "static/media/story.6ebb150f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/social/story.jpg
// module id = 682
// module chunks = 0